export default "__VITE_ASSET__CS3tvgWD__"